import React, { useEffect, useState } from 'react';
import { Tooltip, OverlayTrigger, Modal, Col, Row, Badge, Button } from 'react-bootstrap';
import LoadinSpin from '../ui/LoadinSpin';
import { TblHAnuncios, headTbl } from '../../data/tables';
import { useGetDta } from '../../hooks/useGetDta';
import { useShowColums, useShowColumsHook } from '../../hooks/useShowColums';
import moment from 'moment';
import Confirmation from '../ui/Confirmation';
import Table from '../Table';
import DropDownsCol from '../ui/DropDownsCol';
import classNames from 'classnames';
import { getInitialColumns } from '../../data/cards';
const baseUrl = process.env.REACT_APP_API;

const TblAnuncios = ({ tab }) => {
    const { loading, data, getInfo } = useGetDta(`proxy`);

    const initialColums = getInitialColumns('proxy', TblHAnuncios);
    const { toggleCheck, columnasVisibles } = useShowColumsHook(initialColums, 'proxy');

      

    const [showd, setShowd] = useState(false);
    const [info, setInfo] = useState({});
    const [zoom, setZoom] = useState();
    const [modal, setModal] = useState(false);

    useEffect(() => {
        getInfo();
    }, [tab]);

    if (loading) return <LoadinSpin />;
    const showImg = (url) => {
        setZoom(url);
        setModal(true);
    };

    const ActionColumn = ({ row }) => {
        return (
            <>
                <>
                    <OverlayTrigger placement="left" overlay={<Tooltip id="overlay-example"> Borrar </Tooltip>}>
                        <i className="mdi mdi-delete mdi-18px " onClick={() => dele(row.original.id)}></i>
                    </OverlayTrigger>
                </>
            </>
        );
    };
    const Imagen = ({ row }) => {
        return (
            <>
                <img
                    src={baseUrl + row.original.foto}
                    alt="FOTO"
                    width={'50px'}
                    onClick={() => showImg(row.original.foto)}
                />
            </>
        );
    };
    const fechaCell = ({ row }) => {
        return (
            <>
                {moment(
                    `${row.original.now === 1 ? row.original.createdAt : `${row.original.fecha} ${row.original.hora}`}`
                ).format('YYYY-MM-DD HH:mm:ss')}{' '}
            </>
        );
    };
    const Cli = ({ row }) => {
        return <Badge className={classNames(' fs-5', 'bg-info')}>{row.original.clientes}</Badge>;
    };
    const Clip = ({ row }) => {
        return <Badge className={classNames(' fs-5', 'bg-warning')}>{row.original.pendientes}</Badge>;
    };
    const CliEn = ({ row }) => {
        return <Badge className={classNames(' fs-5', 'bg-success')}>{row.original.enviados}</Badge>;
    };

    const EmitCell = ({ row }) => {
        const opp = JSON.parse(row.original.opp);
        return (
            <>
                <Row>
                    <Col xl="auto">
                        {' '}
                        <h3>
                            <span className="badge badge-success-lighten">{row.original.emit}</span>
                        </h3>
                    </Col>
                    <Col>
                        <Row>
                            {' '}
                            {opp.map((op, index) => {
                                return (
                                    <Col>
                                        <Badge pill className={classNames(' mt-2', 'bg-success')} key={index}>
                                            {op.label}
                                        </Badge>
                                    </Col>
                                );
                            })}{' '}
                        </Row>
                    </Col>
                </Row>{' '}
            </>
        );
    };
    const TipoCell = ({ row }) => {
        let opps = JSON.parse(row.original.tipo);
        return (
            <>
                {opps.map((op, index) => (
                    <span className="badge bg-info mx-1" key={index}>
                        {op.value === 'app' && 'Aplicación/Portal web'}
                        {op.value === 'proxy' && 'Cliente'}
                        {op.value === 'cx' && 'Sistema Cx'}
                    </span>
                ))}
            </>
        );
    };
    const columns = [
        {
            Header: 'Clave',
            accessor: 'keey',
            sort: true,
        },
        {
            Header: 'Tipo',
            accessor: 'tipo',
            sort: true,
            Cell: TipoCell,
        },
        {
            Header: 'Imagen',
            accessor: 'foto',
            sort: true,
            Cell: Imagen,
        },
        {
            Header: 'Nombre',
            accessor: 'nombre',
            sort: true,
        },
        {
            Header: 'Descripción',
            accessor: 'descripcion',
            sort: true,
        },

        {
            Header: 'Emitido por ',
            accessor: 'emit',
            sort: true,
            Cell: EmitCell,
        },
        {
            Header: 'Clientes',
            accessor: 'clientes',
            sort: true,
            Cell: Cli,
        },
        {
            Header: 'Pendientes',
            accessor: 'pendientes',
            sort: true,
            Cell: Clip,
        },
        {
            Header: 'Enviados',
            accessor: 'enviados',
            sort: true,
            Cell: CliEn,
        },
        {
            Header: 'Fecha de emisión',
            accessor: 'fecha',
            sort: true,
            Cell: fechaCell,
        },

        {
            Header: 'Acción',
            accessor: 'action',
            sort: false,
            classes: 'table-action',
            Cell: ActionColumn,
        },
    ];
    const sizePerPageList = headTbl(data.length);
    const dele = (id) => {
        setInfo({ id, type: 'SCREEN' });
        setShowd(true);
    };

    return (
        <div>
            <Confirmation show={showd} toggle={() => setShowd(false)} info={info} callBk={getInfo} />

            <Table
                columns={columns}
                data={data}
                pageSize={25}
                sizePerPageList={sizePerPageList}
                isSortable={true}
                pagination={true}
                isSearchable={true}
                columnasVisibles={columnasVisibles}
                theadClass="table-light"
                searchBoxClass="mb-2"
                visiblesCustum={
                    <DropDownsCol
                        cols={columnasVisibles} // Pasar el estado desde TblZonas
                        toggleCheck={toggleCheck} // Pasar la función de toggleCheck desde TblZonas
                    />
                }
            />
            <Modal size="lg" centered show={modal} onHide={() => setModal(false)}>
                <img src={baseUrl + `${zoom}`} alt="ANUNCIO" width={'100%'} />
            </Modal>
        </div>
    );
};

export default TblAnuncios;
